import { Spinner, Message } from '..'
import {
  inputText,
  inputTextArea,
  inputMultipleCheckBox,
} from '../../utils/dynamicForm'

const FormRoles = ({
  edit,
  formCleanHandler,
  isLoading,
  register,
  isError,
  errors,
  isLoadingUpdate,
  isLoadingPost,
  handleSubmit,
  submitHandler,
  error,
  permissionData,
  clientPermissionData,
}) => {
  return (
    <div
      className='modal fade'
      id='roleModal'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='roleModalLabel'
    >
      <div className='modal-dialog modal-lg'>
        <div className='modal-content modal-background'>
          <div className='modal-header'>
            <h3 className='modal-title ' id='roleModalLabel'>
              {edit ? 'Editar Rol' : 'Publicar Rol'}
            </h3>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={formCleanHandler}
            ></button>
          </div>
          <div className='modal-body'>
            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <Message variant='danger'>{error}</Message>
            ) : (
              <form onSubmit={handleSubmit(submitHandler)}>
                {inputText({
                  register,
                  errors,
                  label: 'Nombre',
                  name: 'name',
                  placeholder: 'Nombre',
                })}

                {inputTextArea({
                  register,
                  errors,
                  label: 'Descripción',
                  name: 'description',
                  placeholder: 'Descripción',
                })}

                <div className='border border-secondary p-2'>
                  <label htmlFor='permission'>API Permisos</label>
                  {inputMultipleCheckBox({
                    register,
                    errors,
                    label: 'Permisos',
                    name: 'permission',
                    placeholder: 'Permisos',
                    data:
                      permissionData &&
                      permissionData.map((item) => ({
                        name: `${item.method} - ${item.name} - ${item.description}`,
                        _id: item._id,
                      })),
                    isRequired: false,
                  })}
                </div>

                <div className='border border-secondary p-2 mt-2'>
                  <label htmlFor='clientPermission'>Permiso Cliente </label>
                  {inputMultipleCheckBox({
                    register,
                    errors,
                    label: 'Permiso Cliente',
                    name: 'clientPermission',
                    placeholder: 'Permiso Cliente',
                    data:
                      clientPermissionData &&
                      clientPermissionData.map((item) => ({
                        name: `${item.menu} - ${item.path}`,
                        _id: item._id,
                      })),
                    isRequired: false,
                  })}
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary '
                    data-bs-dismiss='modal'
                    onClick={formCleanHandler}
                  >
                    Cerrar
                  </button>
                  <button
                    type='submit'
                    className='btn btn-primary '
                    disabled={isLoadingPost || isLoadingUpdate}
                  >
                    {isLoadingPost || isLoadingUpdate ? (
                      <span className='spinner-border spinner-border-sm' />
                    ) : (
                      'Actualizar'
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormRoles
